<template>
  <footer class="footer-wrapper">
    <div class="footer">
      <grid-container>
        <grid-row>
          <div class="footer__button-wrapper">
            <button class="footer__button" @click="handleClick"/>
          </div>
          <div class="footer__description">
            <p>
              Comprehensive solutions <br>
              in&nbsp;the field of urban planning
              and&nbsp;architecture
            </p>
          </div>
          <ul class="footer__address">
            <li class="footer__address-item">
              <a class="footer__address-link" href="mailto:biuro@sawawa.com.pl">
                biuro@sawawa.com.pl
              </a>
            </li>
            <li class="footer__address-item">
              <a
                class="footer__address-link"
                href="https://www.facebook.com/pracowniasawawa"
                target="_blank"
              >facebook</a>
              /
              <a
                class="footer__address-link"
                href="https://www.linkedin.com/company/pracownia-sawawa/"
                target="_blank"
              >linkedin</a>
            </li>
            <li class="footer__address-item">
              <a class="footer__address-link" href="tel:+48 22 243 80 08">
                +48 22 243 80 08
              </a>
            </li>
          </ul>

          <div class="footer__copyrights">
            <p>© copyrights 2018 SAWAWA Sp. z o. o.</p>
          </div>

          <div class="footer__devs">
            <span>web design:</span>
            <a
              href="http://www.syfonstudio.com/"
              class="footer__devs-link"
              target="_blank"
            >syfonstudio</a>
            /
            <a
              href="https://panowie-programisci.pl/"
              class="footer__devs-link"
              target="_blank"
            >panowie programisci</a>
          </div>
        </grid-row>
      </grid-container>
    </div>
  </footer>
</template>

<script>
import smoothScroll from 'smoothscrolljs'

export default {
  methods: {
    handleClick () {
      smoothScroll(0)
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-wrapper {
    @include theme(background-color);
    @include vertical-space((top: 2, bottom: 2), padding);
  }

  .footer {
    @include text(big, medium, secondary);

    &__button-wrapper {
      @include hide-down(lg);
      @include grid-column((lg: 2));
    }

    &__button {
      @include reset-button;
      border: $accent-border-width solid $main-opposite-color;
      width: 64px;
      height: 64px;
      border-radius: 50%;
      margin-top: 20px;
      transition: border-color $base-transition;

      &:after {
         content: '→';
         opacity: 0;
         transition: opacity $base-transition;
         transform: translateX(-1px) rotate(270deg);
         display: block;

      }

      &:hover {
        @include theme-opposite(border-color);
        &:after{
           opacity: 1;
           transition: opacity $base-transition;
           transform: translateX(-1px) rotate(270deg);
           display: block;
        }

       }
    }

    &__description {
      @include grid-column((xs: 12, md: 6, lg: 4));
      @include grid-offset((lg: 1));
      @include vertical-space((bottom: 2));

      @include media-up(md) {
        @include vertical-space((bottom: 7));
      }
    }

    &__address {
      @include reset-list;
      @include grid-column((xs: 12, md: 6, lg: 4));

      @include vertical-space((bottom: 2));

      @include media-up(md) {
        @include vertical-space((bottom: 7));
      }

      &-link {
        @include reset-link;

        transition: color $base-transition;

        &:hover {
          @include theme-opposite(color);
        }
      }
    }

    &__copyrights {
      @include grid-column((xs: 12, md: 6, lg: 4));
      @include grid-offset((lg: 3));
      @include text(small, medium, secondary);
    }

    &__devs {
      @include grid-column((xs: 12, md: 6, lg: 4));
      @include text(small, medium, secondary);

      &-link {
        @include reset-link;

        transition: color $base-transition;

        &:hover {
          @include theme-opposite(color);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue